import { render } from "./ColumnSettings.vue?vue&type=template&id=185bf33a&scoped=true"
import script from "./ColumnSettings.vue?vue&type=script&lang=js"
export * from "./ColumnSettings.vue?vue&type=script&lang=js"

import "./ColumnSettings.vue?vue&type=style&index=0&id=185bf33a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185bf33a"]])

export default __exports__